import { type TFunction } from 'i18next'

export type MarketingNavLink = {
	to: string
	label: string
	slug: string
	external?: boolean
}

/**
 * The header nav entries, shared by the desktop nav and the mobile Sheet so
 * the two lists cannot drift. The logo links home, so there is no Home entry.
 */
export function marketingNavLinks(
	localePath: (path: string) => string,
	t: TFunction,
): MarketingNavLink[] {
	return [
		{ to: localePath('/cloudron'), label: t('nav.cloudron'), slug: 'cloudron' },
		{
			to: localePath('/nextcloud'),
			label: t('nav.nextcloud'),
			slug: 'nextcloud',
		},
		{ to: localePath('/websites'), label: t('nav.websites'), slug: 'websites' },
		{ to: localePath('/coaching'), label: t('nav.coaching'), slug: 'coaching' },
		{ to: '/shop', label: t('nav.shop'), external: true, slug: 'shop' },
		{ to: localePath('/blog'), label: t('nav.blog'), slug: 'blog' },
		{ to: localePath('/about'), label: t('nav.about'), slug: 'about' },
	]
}
